import { Box, CardContent } from "@mui/material";
import { mdiAccountGroupOutline, mdiCalendarCheckOutline, mdiCalendarQuestion, mdiCarSeat } from "@mdi/js";
import Icon from "@mdi/react";

import CardWithAvatar from "components/CardWithAvatar";
import combineObjectsByKey from "utils/combineObjectsByKey";
import { EventRow } from "api/event";
import { GetUserById } from "api/profile";
import { VoteRow, VoteByEventId, VoteType } from "api/vote";
import { VEHICLES } from "../VehicleSelectionDialog/VehicleSelectionDialog";
import EventStatButton from "./EventStatButton";

type Combined = Array<VoteRow & VoteByEventId>;

export interface EventStatsProps {
  event: EventRow;
  users: GetUserById[];
  votes: VoteByEventId[];
  onViewParticipants: () => void;
  onViewPending: () => void;
  onViewVehicles: () => void;
}

function EventStats(props: EventStatsProps) {
  const { users, event, votes, onViewParticipants, onViewPending, onViewVehicles } = props;
  // we must use combine because in the groups does not contain the names, avatars of the users
  const combined: Combined = combineObjectsByKey(users, votes, "uid");
  const participantsVotes: Combined = [];
  const pendingVotes: Combined = [];
  const vehiclesVotes: Combined = [];
  combined.forEach((vote) => {
    if (vote.type === VoteType.PARTICIPATING) {
      participantsVotes.push(vote);
    } else {
      pendingVotes.push(vote);
    }

    if (vote.vehicle_details) {
      vehiclesVotes.push(vote);
    }
  });

  const allAvailableSeats = vehiclesVotes.reduce(
    (previousValue, currentValue) => previousValue + currentValue.vehicle_details!.availableSeats,
    0
  );
  const participantsBadge = event.participants_limit
    ? `${participantsVotes.length}/${event.participants_limit}`
    : participantsVotes.length;

  return (
    <CardWithAvatar icon={<Icon path={mdiAccountGroupOutline} size={1.2} />} title='Stats'>
      <CardContent>
        <Box
          display='flex'
          width='100%'
          gap={{ xs: 1, sm: 4 }}
          sx={{ justifyContent: { xs: "space-evenly", sm: "center" } }}
        >
          <EventStatButton
            label='Participants'
            path={mdiCalendarCheckOutline}
            value={participantsBadge}
            onClick={onViewParticipants}
          />
          <EventStatButton
            label='Pending'
            path={mdiCalendarQuestion}
            value={pendingVotes.length}
            onClick={onViewPending}
          />
          <EventStatButton
            label='Vehicles'
            path={VEHICLES["mid-size-car"].icon}
            value={
              vehiclesVotes.length ? (
                <>
                  {vehiclesVotes.length} ({allAvailableSeats}
                  <Icon path={mdiCarSeat} size={0.6} />)
                </>
              ) : (
                0
              )
            }
            onClick={onViewVehicles}
          />
        </Box>
      </CardContent>
    </CardWithAvatar>
  );
}

export default EventStats;
